import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import styles from './ProjectPreview.module.less';

type Props = {
  dependencyCount: number;
  deepestLevel: number;
  isLimitedScan: boolean;
};

/**
 * Preview content displayed when the scan has passed (no issues)
 */
const PreviewContentPassing: VoidFunctionComponent<Props> = ({
  dependencyCount,
  deepestLevel,
  isLimitedScan,
}) => (
  <>
    <div className="col-md-6">
      <h3 className="margin-top margin-top-responsive">Scan Details</h3>
      <table className="table project-preview-table">
        <tbody>
          <tr>
            <td>License checks performed</td>
            <td>{(dependencyCount + 1) * 3}</td>
          </tr>
          <tr>
            <td>Dependencies scanned</td>
            <td>{dependencyCount}</td>
          </tr>
          <tr>
            <td>Scan type</td>
            <td>
              {!isLimitedScan ? (
                'Full'
              ) : (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="upgradeScanTooltip">
                      Owner&rsquo;s account needs to be upgraded to enable deeper scanning
                    </Tooltip>
                  }
                >
                  <span className={`badge ${styles.limitedBadge}`}>Limited</span>
                </OverlayTrigger>
              )}
            </td>
          </tr>
          <tr>
            <td>Deepest dependency level</td>
            <td>{deepestLevel}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="col-md-1" />
  </>
);

export default PreviewContentPassing;
